export default function Footer({ brand }) {
  return (
    <footer className="section-onyx on-onyx py-12">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img loading="lazy" decoding="async" src="/expansion-rubi-logo.png" alt="" className="w-8 h-8 object-contain opacity-90" />
          <div>
            <div className="font-display text-sm text-[#0A0A0A]">{brand?.title || "Expansión Rubí"}</div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#FFBF57]">{brand?.subtitle || "Proyecto Diamante"}</div>
          </div>
        </div>
        <div className="text-[11px] font-mono text-[#52525B] text-center">
          © {new Date().getFullYear()} Fragancias Rubí · Estructura Asociación en Participación (AEP)
        </div>
        <div className="text-[11px] font-mono text-[#52525B]">{brand?.whatsapp_display}</div>
      </div>
    </footer>
  );
}
